import { useState, useEffect, useRef } from 'react';
import { cn } from '../../lib/utils';

export const VoiceWaveform = ({ 
    isRecording = false,
    audioLevel = 0,
    className 
}) => {
    const [bars, setBars] = useState(Array(24).fill(0.1));
    const animationRef = useRef(null);

    useEffect(() => {
        if (isRecording) {
            const animate = () => {
                setBars(prev => prev.map((_, i) => {
                    const baseLevel = audioLevel || 0.3;
                    const variation = Math.sin(Date.now() / 100 + i * 0.3) * 0.3;
                    return Math.max(0.1, Math.min(1, baseLevel + variation + Math.random() * 0.2));
                }));
                animationRef.current = requestAnimationFrame(animate);
            };
            animate();
        } else {
            setBars(Array(24).fill(0.1));
        }

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, [isRecording, audioLevel]);

    return (
        <div className={cn(
            'flex items-center justify-center gap-1 h-16 px-4 rounded-xl transition-all duration-300',
            isRecording ? 'bg-red-500/10 border border-red-500/30' : 'bg-muted/50',
            className
        )}>
            {bars.map((height, i) => (
                <div
                    key={i}
                    className={cn(
                        'w-1.5 rounded-full transition-all duration-75',
                        isRecording ? 'bg-red-500' : 'bg-muted-foreground/30'
                    )}
                    style={{ 
                        height: `${height * 100}%`,
                        transform: `scaleY(${height})`,
                        transformOrigin: 'center'
                    }}
                />
            ))}
            {isRecording && (
                <div className="ml-3 flex items-center gap-2">
                    <span className="relative flex h-3 w-3">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                    </span>
                    <span className="text-sm font-medium text-red-500">Recording...</span>
                </div>
            )}
        </div>
    );
};
